/**
 * zh-CN —— 跟 zh-HK **逐 key 對齊**（缺／多 key 都會被擋：typecheck ＋ `check:locales`）
 * ⚠️ 唔准加 `as const`（見 `src/locales/en/index.ts` 嘅理由）
 */
export const zhCN = {
  app_name: 'CoSingery',
  app_tagline: '开心、难过、想记住 —— 都可以留一首歌给自己',

  skeleton_title: '骨架已就绪',
  skeleton_body:
    '目前有的是三语界面、设计 token 和构建闸门。对话与生成歌曲会按阶段闸逐块加入（安全层先行）。',
  skeleton_gate_note: '上线前必须通过：构建 ＋ 三语 key 对齐 ＋ 共用方案账簿一致。',

  language_label: '语言',
  locale_zh_hk: '繁體中文（香港）',
  locale_en: 'English',
  locale_zh_cn: '简体中文',

  nav_chat: '对话',
  nav_songs: '我的歌',

  chat_placeholder: '想说什么都可以…',
  chat_send: '发送',
  chat_thinking: '稍等…',
  chat_retry: '再试一次',
  chat_quote: '引用',
  song_lang_label: '歌词语言',
  song_lang_cantonese: '粤语',
  song_lang_mandarin: '国语',
  song_lang_english: 'English',
  song_generate_button: '生成歌曲（约 1–3 分钟）',


  chat_empty_title: '有些时刻，会过去。但那首歌，永远是你的。',
  chat_empty_body:
    'CoSingery 不是教你写歌，也不会帮你代笔。它是一个安静的房间，给你一支笔、一段旋律，让你把今天的自己 —— 开心、失恋、愤怒、心动、怀念…… 好好收藏起来。',
  chat_empty_action: '开始',
  chat_hold_note: '这一刻我们继续聊；歌晚一点再写。',
  chat_error_stream: '连接出了问题，可以再试一次。',
  chat_error_model: '现在连不上模型，请稍后再试。',

  songs_empty_title: '还没有歌',
  songs_empty_body: '聊完之后，你的歌会出现在这里。',
  songs_not_built: '这一页还没做（生成歌曲是下一块）。',
  songs_library_count: '{{n}} 首歌 —— 播放清单包含全部（跨对话）',
  new_chat_button: '＋ 新对话',
  continue_chat_button: '继续聊',
  new_chat_hint: '开新对话不会删掉你的歌 —— 全部留在「我的歌」。',
  new_chat_will_start: '歌完成了 —— 下一条消息会开新对话（想留下就点「继续聊」）。',

  song_generate: '生成一首歌',
  song_generating: '正在写歌词…',
  song_ready: '你的歌写好了',
  song_toggle: '查看全部歌词',
  song_status_label: '状态',
  song_hold_notice: '我们再聊一会儿再写歌，好吗？',
  song_need_more_notice: '想写一首真正属于你的歌 —— 再多说两句那件事给我听，好吗？',
  song_error_generic: '现在写不了歌，稍后再试。',
  song_error_too_generic: '写得太空泛 —— 再多说几句，我想写你真实的经历。',
  song_error_repetitive: '歌词重复太多 —— 再多说几句，让我有新东西可写。',
  song_error_blocked: '写出来的东西不合适，我们换个方向再试。',
// ── 三步流程：① 聊天 → ② 歌词（可修改）→ ③ 开始制作 ──
song_step_1: '① 聊天',
song_step_2: '② 歌词',
song_step_3: '③ 出歌',
song_write_lyrics: '写歌词',
lyrics_review_title: '看看对不对？',
lyrics_review_hint: '可以自己改字、改细节 —— 改完就真的是你的歌。',
lyrics_review_title_label: '歌名',
lyrics_review_lyrics_label: '歌词',
lyrics_review_save: '保存修改',
lyrics_review_saved: '已保存',
lyrics_review_regenerate: '重新写一次',
lyrics_review_confirm: '确定，开始做歌',
lyrics_review_confirm_note: '做歌大约需要 1–3 分钟（真实音乐生成）。',
song_render_pending: '正在制作你的歌…（大约 1–3 分钟）',
song_edit_error_short: '歌词太短了，多写几句。',
song_edit_error_blocked: '这段歌词不适合做成歌 —— 换个写法再试。',
// ── 版本选择（Mureka 一次生成 2 个版本）──
variant_label: '版本',
variant_use: '用这个',
variant_picked: '正在用',
variant_hifi: '高音质',
/** ⭐ 1.1.0（产品负责人 2026-09-23）：点击卡片即选（不再另按按钮）＋ 每个版本都能分享 */
variant_tap_hint: '点一下卡片就选这个版本；可以逐个试听、逐个分享',
/** ⭐ 2026-09-23：没有音频要如实说明（之前消息内 ▶ 按了没反应） */
song_audio_pending: '音频还在生成…（出歌后才能播放）',
song_audio_not_ready: '这首歌还没有音频（可能正在生成）—— 等一会儿再按 ▶',
  /** ⭐ 2026-09-23（产品负责人）：「用我的声音唱」逐首歌开／关 */
  voice_mine_on: '用我的声音唱',
  voice_mine_off: '用预设声音',
  /* ⭐ **2026-09-26（`decisions/051`）**：演唱性别 */
  gender_auto: '自动',
  gender_male: '男声',
  gender_female: '女声',
// ── Must-use box（选字标记「一定要有」）──
must_use_hint: '这段字要写进歌里：',
  must_use_howto: '先点上边一粒，再在输入框选字',
  must_use_armed: '已开启 —— 选字即刻标记；再点一次退出',
  must_use_marked_count: '已标记 {{n}} 句会入歌',


must_use_exact: '要原话（逐字）',
must_use_meaning: '要意思（可改写）',
must_use_remove: '取消标记',
// ── 播放器（底部 tab ＋ 常驻播放条）──
tab_chat: '聊天',
tab_songs: '我的歌',
tab_player: '播放器',
player_now_playing: '正在播放',
player_play: '播放',
player_pause: '暂停',
player_prev: '上一首',
player_next: '下一首',
player_seek: '跳转',
player_hifi_on: '高音质（flac）已开',
player_hifi_off: '一般音质（mp3）',
player_error: '播放出错',
player_empty_title: '还没有歌可以听',
player_empty_body: '去聊几句，先写一首属于你的歌。',
  songs_list_failed: '读不到我的歌，稍后再试。',

  /*
   * ⚠️ 情绪应对（`decisions/009` 乙案）—— **待产品负责人过目（P-25）**
   * 默认＝继续聊、继续写歌；**只有即时危险**才用以下三句（延后写歌，不是禁止）
   * ❌ 空洞话（「加油」／「我明白你的感受」）；❌ 不准承诺保密或永远在场
   */
  // ── ⭐ 2026-09-22 产品负责人 UI／UX 五改（`decisions/023`）──
  send_aria: '发送',
  topbar_new_chat_aria: '新对话',
  topbar_manage_lyrics: '管理歌词',
  topbar_start_song: '开始作歌',
  keep_going_toggle: '继续聊',
  sheet_close_aria: '关闭',
  sheet_start_song_title: '写一首歌',
  sheet_lyrics_title: '歌词',
  /** ⭐ 語體（`decisions/030`）：市場書面（預設）／口語 */
  lyrics_sheet_pick_register: '唱法（想似哪种歌）',
  register_cantopop: '流行曲（市场书面）',
  register_spoken: '口语（贴近我讲的话）',
  register_hint: '市场书面＝书面语为主、句短、像电台歌；口语＝保留你原本说法。',
  lyrics_sheet_pick_lang: '用哪种语言写？',
  lyrics_sheet_edit: '手动编辑',
  lyrics_sheet_cancel: '取消编辑',
  lyrics_sheet_later: '晚点再说',
  must_use_exact_short: '原话',
  must_use_meaning_short: '意思',
  must_use_howto_short: '点按钮 → 选字',

  understanding_start: '开始（我先说回我听到的）',
  understanding_ok: '对，写下去',
  understanding_fix: '想改',
  lyrics_copy: '复制',
  share_button: '分享',
  remake_button: '换风格',
  revise_hint: '说说你想怎么改（例如：第二段用回我的语气）',
  remake_hint: '想要什么风格？（例如：慢一点、钢琴、不要鼓）',
  revise_placeholder: '想改哪句／怎么改？',
  remake_placeholder: '想要什么风格？',
  history_title: '之前的对话',
  history_empty: '还没有其他对话。',
  history_untitled: '（还没有消息）',
  history_songs: '{{n}} 首歌',
  working_hint: '处理中…（请不要离开这一页）',

  edit_hint: '点你想改的句子（可以点多句），然后在下面输入你想怎么改',
  edit_line_placeholder: '你想这句变成怎样？',
  edit_apply_ai: '交给 AI 改',
  edit_apply_direct: '直接套用',
  edit_done: '完成',
  pick_hint: '在上面的消息点你想写进歌里的句子（再点一下取消）',
  style_title: '想要什么风格？',
  style_start: '开始生成（收费）',
  /** ⭐ 1.1.0：快速清单 ＋〔全部风格〕（`decisions/034`） */
  style_quick_label: '快速选（你可以加减）',
  style_show_all: '全部风格（{{n}}）',
  style_collapse: '收起',
  style_quick_add: '加入快速清单／移出',
  style_slow: '慢歌',
  style_upbeat: '轻快',
  style_piano: '钢琴',
  style_guitar: '木吉他',
  style_drums: '鼓',
  style_nodrums: '不要鼓',
  style_lofi: 'Lo-fi',
  style_jazz: '爵士',
  style_electronic: '电子',
  style_strings: '弦乐',
  style_rock: '摇滚',
  style_folk: '清新民谣',
  go_player: '去播放器',
  share_song_text: '这首歌是我用 CoSingery 写的',
  share_file_fallback_note: '你的浏览器不支持直接分享文件，已改为分享链接',
  /** ⭐ 2026-09-23（share-button 1.2.0）：分享要有反应、不无限等待、失败要如实说 */
  share_preparing: '正在准备文件…',
  share_timeout_note: '文件太慢／取不到 —— 已改为分享文字＋链接（可以再点一次重试）',
  share_gesture_note: '系统不允许分享文件（通常因为等太久）—— 已改为分享文字＋链接',
  mode_listener: '聆听者',
  mode_chat: '聊天',
  mode_switch_aria: '对话模式',
  chat_mode_hint: '这个模式可以聊任何事 —— 音乐照样帮你写。',
  chat_mode_placeholder: '想说什么都可以…',
  diary_prev: '上一页',
  diary_next: '下一页',
  diary_page_aria: '日记本',
  diary_done_only: '只收已完成（有歌）的日记',
  diary_write_label: '我想记下的感受',
  diary_write_placeholder: '写下你现在想说的…（自动保存）',
  diary_saving: '保存中…',
  diary_saved: '已保存',
  diary_save_failed: '保存不了，可以重试',
  diary_retry: '重试',
  diary_lyrics_title: '这首歌的歌词',
  diary_no_audio: '这首还没出音乐（可以在聊天里再按〔出歌〕）',
  diary_empty_title: '日记本还没开始',
  diary_empty_body: '完成一首歌之后，这里会出现一页 —— 有日期、你的感受、歌词和播放器。',
  history_rename: '改名',
  /** ⭐ 0016（`decisions/039`）：改歌名（日记页歌名旁 ✎） */
  song_rename: '改歌名',
  song_rename_title: '给这首歌起个名字',
  song_rename_placeholder: '例如：尾班车与月光',
  song_rename_empty: '歌名不能空白',
  history_delete: '删除',
  history_rename_title: '给这个对话起个名字',
  history_name_placeholder: '例如：跟妈妈那件事',
  history_save: '保存',
  history_cancel: '取消',
  history_delete_title: '确定删除这个对话？',
  history_delete_warning: '消息会被删除，无法恢复。（你的歌会留在「我的歌」。）',
  history_delete_confirm: '删除对话',
  history_rename_failed: '改不了名',
  history_delete_failed: '删不掉',
  diary_title: 'My Feeling Diary',
  tab_me: '我的',
  me_identity_title: '身份',
  me_identity_note: '你现在用的是「设备身份」（未登录）—— 换手机或清掉浏览器数据，我们就找不回你的歌。登录功能是下一步。',
  me_identity_id: '设备编号',
  me_billing_title: '付款管理（香港网上付款）',
  me_credits: '可用额度（可以出几首歌）',
  me_billing_provider: '收款状态',
  me_billing_ready: '已接通',
  me_billing_not_ready: '未接通',
  me_billing_no_pricing: '未定价（还没有方案）',
  me_billing_needs: '要开通香港网上收款，需要你（产品负责人）提供：\n① 商户帐户／收款方式（FPS 转数快／信用卡／PayPal／PayMe…）\n② 每首（或每套）的定价（HK$）\n③ 退款政策\n④ provider 的 API key（我们只放在 Cloudflare secret，不会写进代码）',
  me_billing_refund_note: '⚠️ 未接通之前不会有任何收费；接通之后每笔订单都会如实列在上面。',
  me_orders_title: '订单',
  me_orders_empty: '还没有订单',
  /** ⭐ 0017（`decisions/041`）：**登录（Email Magic Link）＋ 免费试用 ＋ 额度** */
  login_title: '欢迎来到 CoSingery',
  login_subtitle: '留下 email 就行 —— 第一次送你 1 首歌。',
  login_email_label: '你的 email',
  login_email_placeholder: 'you@example.com',
  /** ⭐ `decisions/044`／`045` 0020d：**两个按钮**（下面一格自动判断 6 位数字／邀请码） */
  login_send_email_only: '用 email 登录',
  login_send_with_invite: '用邀请码登录',
  login_error_invite_required_hint: '这个 email 未登记 —— 输入邀请码再试。',
  login_sending: '正在寄…',
  login_sent_notice: '已经寄到 {{email}} —— 输入下面 6 位数字就能登入。',
  login_sent_hint: '找不到？看看垃圾邮件。（只认最新一封）',
  /** ⭐ 0020（`decisions/045`）：**6 位数字**（自动判断；够 6 位自动登入） */
  login_code_label: '6 位数字',
  login_code_placeholder: '123456',
  login_code_busy: '正在核对…',
  login_need_email_short: '先输入 email，再输入数字。',
  login_code_error_invalid: '这串数字不对，或者已经用过／过期 —— 可以再寄一条新的。',
  login_code_error_network: '网络有点问题，再试一次。',
  login_devlink_label: '（本机开发）登录链接：',
  login_error_email_invalid: '这个 email 好像不对，再检查一次。',
  login_error_send_failed: '现在寄不出邮件，请稍后再试。',
  login_error_too_many: '按得太频繁，等一会再试。',
  login_error_link_invalid: '这条登录链接已经用过或者过期 —— 再寄一条新的给你。',
  login_error_generic: '登录有点问题',
  login_privacy_note: '不会寄广告；email 只用来登录和寄收据。',
  /** ⭐ 0018（`decisions/042`）：**Beta 邀请制** */
  login_beta_notice: '🧪 测试期：需要邀请码，每人 1 首免费，暂时不收任何钱。',
  login_invite_label: '邀请码',
  login_invite_placeholder: 'INV-XXXX-XXXX-XXXX',
  login_error_invite_required: '这个测试期需要邀请码 —— 请先输入邀请码（没有就跟我说一声）。',
  login_error_invite_invalid: '这个邀请码不对、已经用过、或者过期了 —— 跟我说一声我发一个新的给你。',
  login_error_invite_mismatch: '这个邀请码已经绑定另一个 email —— 想用这个 email 就需要一个新邀请码。',
  login_direct_link_notice: '✅ 邀请码正确 —— 点下面这条链接就可以登入（15 分钟内有效，只能用一次）：',
  /** ⭐ 0019（`decisions/043`）：**意见回馈 ＋ 公司资料** */
  feedback_title: '给点意见（Beta）',
  feedback_privacy_note:
    '⚠️ 只会送出你打的字（不会自动附带歌词／日记）；只有我（产品负责人）看得到，用来改下一版。',
  feedback_kind_ux: '体验',
  feedback_kind_bug: '问题',
  feedback_kind_idea: '想法',
  feedback_kind_other: '其他',
  feedback_score_label: '整体感觉',
  feedback_placeholder: '哪里卡住？哪样你最想要？（一两句就够）',
  feedback_send: '送出',
  feedback_sending: '正在送出…',
  feedback_cancel: '晚点再说',
  feedback_thanks: '收到了，谢谢你 🙏（我会看，会用来改下一版）',
  feedback_error_empty: '写一句才可以送出。',
  feedback_error_too_many: '今天到上限了，明天再说也不迟。',
  feedback_error_generic: '现在送不出',
  me_feedback_button: '给点意见',
  me_feedback_hint: 'Beta 测试期：你的意见直接影响下一版。',
  legal_provider: '服务提供者',
  legal_br: '商业登记号码（BR）',
  legal_address: '地址',
  legal_email: '联络',
  legal_missing: '待提供',
  legal_policies_pending: '（服务条款／退款政策／隐私政策：准备中）',
  legal_load_failed: '读不到服务提供者资料',
  pay_payee_label: '收款方',
  me_logged_in_as: '登录帐号',
  me_logout: '登出',
  me_credits_title: '可用额度',
  me_credits_left: '还可以做 {{n}} 首歌',
  me_credits_none: '已经没有额度 —— 买一个套餐就可以继续做歌。',
  me_credits_free_trial: '（其中 1 首是免费试用）',
  me_topup_cta: '去买套餐',
  pack_p10: '10 首歌',
  pack_p25: '25 首歌',
  pack_p75: '75 首歌',
  render_variants_one: '1 个版本',
  render_variants_two: '2 个版本（可以挑）',
  song_error_insufficient_credits: '没有额度了 —— 去「我的」买一个套餐，就可以继续做歌。',
  song_error_login_required: '请先登录，才可以做歌。',
  me_about_title: '关于',
  /** ⭐ 2026-09-23：恢复我的歌（清浏览器数据／换机之后救回 library） */
  restore_title: '恢复我的歌',
  restore_warn:
    '⚠️ 目前是「设备身份」（还没有登录）：**清除浏览器数据／换机**会让这台设备的 library 变空（歌其实还在），保存下面那个码就能救回来。',
  restore_code_label: '你的恢复码',
  restore_no_code: '（读不到）',
  restore_copy: '复制恢复码',
  restore_copied: '已复制 —— 建议贴到自己的记事本／密码管理器保存',
  restore_input_placeholder: '贴上旧的恢复码',
  restore_button: '恢复',
  restore_busy: '查询中…',
  restore_invalid: '这个码格式不对（应该是一串 16–64 位英数字／横线）',
  restore_failed_empty: '这个恢复码名下**找不到歌**（没有改动你现在的数据）',
  restore_failed_offline: '现在查不到（网络问题）—— 请再试（没有改动你的数据）',
  restore_ok: '已恢复 ✓ 正在载入你的歌…',
  restore_emergency_hint: '⚠️ 如果这一页看不到「恢复我的歌」（app 未更新），请直接打开紧急恢复页：',
  me_build_label: '外壳版本',
  me_build_unknown: '读不到',
  /** ⭐ 2026-09-23#3（B1）：分享能力探针 */
  me_share_probe_label: '分享能力',
  me_share_probe_legend: '（📄 文件／🖼 图片／💬 文字／📱 已装 app；✓ 支持／✗ 不支持）',
  /** ⭐ 2026-09-23#3（B2）：iOS 主屏幕 app 与 Safari 分开存储 */
  restore_card_title: '已经装到主屏幕？／从 Safari 过来？',
  restore_card_body:
    'iPhone 上「主屏幕 app」与 Safari 是**分开存储**（各自身份）→ 在这里贴回你的恢复码，歌马上回来。',
  restore_ios_note:
    'iPhone：Safari 按〔复制恢复码〕→ 打开主屏幕 app → 在这里贴（Apple 不允许链接直接打开主屏幕 app；Android 可以）。',
  /** ⭐ 2026-09-23#3：分享失败要讲原因 */
  share_failed_note: '分享不成功（系统回报原因）',
  share_file_unsupported_note: '这台设备不支持「连文件一起分享」——改为只分享文字／链接。',
  /** ⭐ 2026-09-23#4：显示「这台机现在」有几首 */
  restore_own_count: '（这台机 {{n}} 首）',
  restore_own_count_unknown: '（读不到）',
  restore_which_code_hint:
    '提示：上面「你的恢复码」＝ **这台机现在**在用的码。要救回旧歌，要贴**另一个**（旧机／Safari 那边「我的」显示的码）。',
  restore_failed_same_code:
    '⚠️ 你贴的就是**这台机现在**的码（0 首）—— 要贴**旧有歌那个码**（你之前记下的），不是上面那个。',
  /** ⭐ 2026-09-23#5（`decisions/031`）：公开分享页 + 分享整页 */
  share_page_button: '分享整页',
  share_page_creating: '建立分享链接…',
  share_page_created: '已建立分享链接（{{days}} 天后失效）——可以分享或复制',
  share_page_share: '分享链接',
  share_page_copy: '复制链接',
  share_page_copied: '已复制链接',
  share_page_revoke: '撤回',
  share_page_revoked_ok: '已撤回（链接马上失效）',
  share_page_includes: '分享页包括：日期／歌名／播放器／歌词／你写的感受（⚠️ 收到链接的人会看到这些）',
  share_page_text: '我有一页 My Feeling Diary 想跟你分享：',
  share_page_shared: '已交给系统分享',
  share_page_share_failed: '分享不了（可以试〔复制链接〕）',
  share_page_from: '一位朋友跟你分享了这首歌',
  share_page_meta: '已经有 {{views}} 次浏览',
  share_page_not_found: '这条分享链接不存在（可能打错字）',
  share_page_revoked: '这条分享已经被撤回 🚫',
  share_page_expired: '这条分享已经过期',
  share_page_failed: '现在看不到这条分享',
  /** ⭐ 2026-09-23#6：多版本 → 如实讲分享哪一版（只会播选中的那版） */
  share_page_version: '第 {{n}} 版／共 {{total}} 版',
  me_version: '版本',
  me_load_failed: '读不到数据',
  me_refresh: '重新整理',
  me_methods_not_set: '还没设置收款码（产品负责人要放上 FPS／AlipayHK／WeChat Pay 的收款 QR 图）。',
  me_manual_pick_pack: '选套餐',
  me_manual_pick_method: '选付款方式',
  me_manual_create: '建立订单',
  me_manual_reference: '参考编号',
  me_manual_pay_hint: '请用上面的收款码付款，并在备注写上参考编号 —— 我们核对更快。',
  me_manual_pending: '状态：等待你付款',
  me_manual_claimed: '状态：已收到你说已付款，等确认（通常几小时内）',
  me_manual_paid: '状态：已入帐 ✅（额度已加）',
  me_manual_claim_button: '我已经付款',
  me_manual_confirm_note: '⚠️ 个人收款码没有自动通知 —— 我们会人工核对（通常几小时内）；核对完额度才会加。',
  /* ── ⭐ 2026-09-26：**产品负责人专用**（确认收款；`OWNER_EMAILS` 对得上才有）── */
  me_owner_queue_title: '等你确认收款',
  me_owner_queue_empty: '没有单等你确认 👍',
  me_owner_confirm_button: '确认收到钱（入额度）',
  me_owner_confirmed: '已确认 ✅',
  me_owner_queue_hint: '只显示「已付款／待付款」的单；确认之后额度立刻加到买家账号（同一张单不会加两次）。',
  /* ── ⭐ 播放清单／分类（0013；`decisions/033`；产品负责人 2026-09-24）── */
  /** 12 个心情／用途分类（slug 固定在 `src/playlists.ts`；这里只是显示文字） */
  pl_favourite: '我的最爱',
  pl_happy: '开心',
  pl_sad: '难过',
  pl_excited: '兴奋',
  pl_celebrate: '庆祝',
  pl_to_my_love: '给我爱的人',
  pl_missing: '思念',
  pl_gratitude: '感恩',
  pl_healing: '疗愈',
  pl_cheer: '勇气',
  pl_proud: '骄傲',
  pl_angry: '生气／不甘心',
  pl_fun: '好玩／好笑',
  /** 加入清单（对话消息／日记页的〔分享〕旁边） */
  playlist_add_button: '添加到播放清单',
  playlist_sheet_title: '加到哪个清单？',
  playlist_sheet_hint: '可以加多个 —— 分类由你自己选，我们不会自动帮你分。',
  playlist_added_note: '已加入「{{name}}」',
  playlist_already_note: '「{{name}}」本来就有这首歌',
  playlist_removed_note: '已从「{{name}}」移出',
  playlist_not_in_note: '本来就不在这个清单',
  playlist_untitled: '未命名清单',
  playlist_membership_failed: '读不到你加入了哪些清单',
  playlist_action_failed: '做不到（{{error}}）',
  playlist_new_label: '新建一个清单',
  playlist_new_placeholder: '例如：跑步听',
  playlist_new_button: '开',
  playlist_new_failed: '开不到（{{error}}）',
  playlist_done: '完成',
  playlist_count: '{{n}} 首',
  playlist_all_songs: '全部歌',
  playlist_load_failed: '读不到这个清单的歌',
  player_play_all: '▶ 播放全部',
  /** ⭐ 2026-09-24：播放器页（清单→歌→播放器→左翻歌词） */
  player_diary_label: '你写的日记',
  player_no_lyrics: '这首歌还没有歌词',
  player_deck_aria: '播放器／歌词（向左翻看歌词）',
  player_back_to_list: '回到歌单',
  /** ⭐ 2026-09-24：播放器基本功能（循环／随机／我的最爱） */
  player_repeat_off: '不循环（播到最后就停）',
  player_repeat_one: '单曲循环',
  player_repeat_all: '全部循环',
  player_shuffle_on: '随机播：开',
  player_shuffle_off: '随机播：关',
  player_fav_add: '加入我的最爱',
  player_fav_remove: '从我的最爱移走',
  player_sequence_note: '一首接一首播放（播到最后就停）',
  diary_mode_diary: '日记',
  diary_mode_list: '清单',
  diary_mode_switch_aria: '看法（日记／清单）',
  diary_play_through: '▶ 顺着播',
  /** ⭐ 2026-09-24：日记页页码（像翻书） */
  diary_page_of: '第 {{n}} 页 / 共 {{total}} 页',
  /** ⭐ `page-flip` 1.2.0：页角提示（像翻书） */
  flip_hint_prev: '翻回之前',
  flip_hint_next: '翻去之后',
  /** ⭐ 2026-09-24：日记字数上限提示（只是防滥用上限；不会妨碍正常书写） */
  diary_too_long: '日记太长（上限 {{max}} 字）—— 可以分几篇写',
  playlist_empty: '这个清单还没有歌',
  playlist_empty_hint: '去「我的歌」或聊天，按〔添加到播放清单〕',
  /* ── ⭐ 0014 音樂風格（`decisions/034`；產品負責人 2026-09-24）── */
  genre_label: '音乐风格',
  genre_auto: '自动（AI 帮你选）',
  genre_self: '自己选',
  genre_auto_note: 'AI 会按你讲的东西挑一个接近的风格；想自己选就按右边。',
  genre_auto_picked: 'AI 选了：{{name}}',
  genre_kpop: '韩国流行（K-POP）',
  genre_cantopop: '粤语流行（HK POP）',
  genre_mandopop: '华语流行',
  genre_ballad: '抒情慢歌',
  genre_piano: '钢琴版',
  genre_acoustic: '木吉他',
  genre_rock: '摇滚',
  genre_rap: '说唱（Rap）',
  genre_rnb: 'R&B',
  genre_edm: '电子舞曲（EDM）',
  genre_lofi: 'Lo-fi',
  genre_jazz: '爵士',
  genre_citypop: '城市流行',
  genre_dreampop: '梦幻流行',
  genre_indie: '独立（Indie）',
  genre_folk: '民谣',
  genre_country: '乡村',
  genre_blues: '蓝调',
  genre_soul: '灵魂',
  genre_funk: '放克',
  genre_disco: '迪斯科',
  genre_house: 'House',
  genre_techno: 'Techno',
  genre_trap: 'Trap',
  genre_dnb: 'Drum & Bass',
  genre_reggae: '雷鬼',
  genre_latin: '拉丁',
  genre_bossanova: 'Bossa nova',
  genre_ambient: '氛围（Ambient）',
  genre_chill: '慢板放松（Chill）',
  genre_unplugged: '不插电',
  genre_metal: '金属',
  genre_punk: '朋克',
  genre_synthwave: '合成波（Synthwave）',
  genre_orchestral: '管弦乐',
  genre_classical: '古典',
  genre_musical: '音乐剧',
  genre_anime: '动漫风',
  genre_chinesestyle: '中国风',
  genre_lullaby: '摇篮曲',
  safety: {
    hold_intro: '我听到你说的了。这一刻我不急着说别的，我想先陪你。',
    hold_ask: '你现在不需要一个人 —— 有没有人可以马上联系到？（家人、朋友、同事都可以）',
    hold_song_later: '我们继续聊。你想的时候，我再帮你写一首歌，看看帮不帮到你。',
  },

  /* ⭐ 2026-10-11 UI v2 新 key（来源：design/strings.js NEW；设计 R-03「新增·待批」） */
  menu_open_aria: '打开菜单',
  drawer_aria: '菜单',
  nav_playlists: '播放列表',
  nav_settings: '设置',
  settings_title: '设置',
  settings_back_aria: '返回',
  settings_font_size: '字体大小',
  settings_font_size_hint: '标题、歌词、日记的手写字，和按钮、列表一起放大。',
  font_scale_1: '小',
  font_scale_2: '标准',
  font_scale_3: '大',
  font_scale_4: '特大',
  font_scale_5: '最大',
  font_scale_preview: '今天有些事，想慢慢说。',
  settings_theme: '外观',
  theme_light: '日间',
  theme_dark: '夜晚',
  theme_system: '跟随系统',
  settings_notify: '通知',
  notify_song_ready: '歌写好了就通知我',
  notify_song_ready_hint: '只会通知这一项，不会催你回来。',
  settings_account: '账号与额度',
  settings_privacy: '隐私与匿名',
  privacy_anon_note: '对话、歌词和日记只属于你。分享出去的页面不会显示你的 email 或账号。',
  settings_export: '导出日记',
  export_hint: '把全部日记页（日期、感受、歌词）下载成一个文件。',
  export_button: '导出',
  gen_stage_aria: '生成进度',
  gen_stage_listen: '听清楚你说的',
  gen_stage_lyrics: '写歌词',
  gen_stage_compose: '作曲与编曲',
  gen_stage_mix: '混音',
  gen_keep_chatting: '你可以继续聊 —— 写好了会在这里出现。',
  player_open_aria: '打开播放器',
  player_speed: '速度',
  player_volume: '音量',

  /* ⭐ 2026-10-11（decisions/053）：底部 tab bar 3 格 */
  tab_diary: '情绪日记',
  tab_playlists: '播放列表',
};
